import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'

const SECCIONES_ETAPA0 = [
  'Contexto y Entorno',
  'Propuesta de Valor',
  'Segmentos y Canales',
  'Fuentes de Ingreso y Estructura de Costos',
  'Capacidades y Recursos Clave',
  'Relaciones con Clientes',
  'Alianzas y Partners Estratégicos',
]

const ESTADOS = ['Sin validar', 'Confirmada', 'Cuestionada']
const PRIORIDADES = ['alta', 'media', 'baja']

const ESTADO_CONFIG = {
  'Confirmada':   { icon: '🟢', color: '#065F46', bg: '#D1FAE5', border: '#6EE7B7' },
  'Cuestionada':  { icon: '🔴', color: '#7F1D1D', bg: '#FEE2E2', border: '#FCA5A5' },
  'Sin validar':  { icon: '🟡', color: '#78350F', bg: '#FEF3C7', border: '#FDE68A' },
}

const PRIO_COLORS = {
  alta:  { color: '#EF4444', bg: '#FEE2E2' },
  media: { color: '#F59E0B', bg: '#FEF3C7' },
  baja:  { color: '#10B981', bg: '#D1FAE5' },
}

export default function AfirmacionesTab({ consultancyId, phaseId }) {
  const [afirmaciones, setAfirmaciones] = useState([])
  const [loading, setLoading]           = useState(true)
  const [view, setView]                 = useState('lista')    // 'lista' | 'documento'
  const [filterSec, setFilterSec]       = useState('Todas')
  const [filterEst, setFilterEst]       = useState('Todos')
  const [showAdd, setShowAdd]           = useState(false)
  const [addForm, setAddForm]           = useState({ seccion_nombre: SECCIONES_ETAPA0[0], estado: 'Sin validar', prioridad: 'media', texto: '', fuente: '' })
  const [saving, setSaving]             = useState(false)
  const [expandedId, setExpandedId]     = useState(null)

  useEffect(() => {
    if (consultancyId) fetchAfirmaciones()
  }, [consultancyId])

  async function fetchAfirmaciones() {
    setLoading(true)
    const { data } = await supabase
      .from('afirmaciones')
      .select('*, stakeholders(nombre, cargo, tipo_rol)')
      .eq('consultancy_id', consultancyId)
      .order('created_at', { ascending: false })
    setAfirmaciones(data || [])
    setLoading(false)
  }

  async function addAfirmacion() {
    if (!addForm.texto.trim()) return
    setSaving(true)
    const { data } = await supabase
      .from('afirmaciones')
      .insert({ ...addForm, consultancy_id: consultancyId })
      .select('*, stakeholders(nombre, cargo, tipo_rol)')
      .single()
    setSaving(false)
    if (data) {
      setAfirmaciones(prev => [data, ...prev])
      setAddForm({ seccion_nombre: SECCIONES_ETAPA0[0], estado: 'Sin validar', prioridad: 'media', texto: '', fuente: '' })
      setShowAdd(false)
    }
  }

  async function updateEstado(id, estado) {
    await supabase.from('afirmaciones').update({ estado, updated_at: new Date().toISOString() }).eq('id', id)
    setAfirmaciones(prev => prev.map(a => a.id === id ? { ...a, estado } : a))
  }

  async function deleteAfirmacion(id) {
    if (!confirm('¿Eliminar esta afirmación?')) return
    await supabase.from('afirmaciones').delete().eq('id', id)
    setAfirmaciones(prev => prev.filter(a => a.id !== id))
  }

  const filtered = afirmaciones.filter(a => {
    const secOk = filterSec === 'Todas' || a.seccion_nombre === filterSec
    const estOk = filterEst === 'Todos' || a.estado === filterEst
    return secOk && estOk
  })

  const stats = {
    total:      afirmaciones.length,
    confirmadas: afirmaciones.filter(a => a.estado === 'Confirmada').length,
    cuestionadas: afirmaciones.filter(a => a.estado === 'Cuestionada').length,
    sinValidar: afirmaciones.filter(a => a.estado === 'Sin validar').length,
  }

  if (loading) return <div style={{ padding: 32, color: '#9CA3AF', textAlign: 'center' }}>Cargando afirmaciones…</div>

  return (
    <div>
      {/* Stats + view toggle */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20, alignItems: 'center' }}>
        <div style={{ display: 'flex', gap: 10, flex: 1 }}>
          {[
            { label: 'Total', value: stats.total, color: '#6366F1' },
            { label: '🟢 Confirmadas', value: stats.confirmadas, color: '#10B981' },
            { label: '🔴 Cuestionadas', value: stats.cuestionadas, color: '#EF4444' },
            { label: '🟡 Sin validar', value: stats.sinValidar, color: '#F59E0B' },
          ].map(s => (
            <div key={s.label} style={{
              background: '#fff', border: '1px solid #E5E7EB', borderRadius: 8,
              padding: '8px 14px', textAlign: 'center', minWidth: 80
            }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: s.color }}>{s.value}</div>
              <div style={{ fontSize: 11, color: '#9CA3AF' }}>{s.label}</div>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => setShowAdd(s => !s)} style={{
            padding: '7px 14px', borderRadius: 8, border: 'none',
            background: '#6366F1', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer'
          }}>+ Agregar</button>
          <button
            onClick={() => setView(v => v === 'lista' ? 'documento' : 'lista')}
            style={{
              padding: '7px 14px', borderRadius: 8, border: '1px solid #E5E7EB',
              background: view === 'documento' ? '#F0FDF4' : '#fff',
              color: view === 'documento' ? '#065F46' : '#374151',
              fontSize: 13, fontWeight: 600, cursor: 'pointer'
            }}
          >{view === 'lista' ? '📄 Documento Vivo' : '📋 Lista'}</button>
        </div>
      </div>

      {/* Add form */}
      {showAdd && (
        <div style={{ background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 10, padding: '16px 18px', marginBottom: 20 }}>
          <div style={{ fontWeight: 700, fontSize: 13, color: '#374151', marginBottom: 12 }}>Nueva Afirmación</div>
          <div style={{ marginBottom: 10 }}>
            <label style={{ fontSize: 11, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 }}>Texto *</label>
            <textarea
              rows={3}
              value={addForm.texto}
              onChange={e => setAddForm(f => ({...f, texto: e.target.value}))}
              placeholder="Ej: La empresa tiene una propuesta de valor diferenciada en el segmento premium, pero carece de proceso formal para comunicarla…"
              style={{ width: '100%', padding: '7px 10px', borderRadius: 7, border: '1px solid #D1D5DB', fontSize: 13, resize: 'vertical', outline: 'none', boxSizing: 'border-box' }}
            />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '8px 10px', marginBottom: 12 }}>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 }}>Sección</label>
              <select value={addForm.seccion_nombre} onChange={e => setAddForm(f => ({...f, seccion_nombre: e.target.value}))}
                style={{ width: '100%', padding: '6px 8px', borderRadius: 6, border: '1px solid #D1D5DB', fontSize: 12, outline: 'none' }}>
                {SECCIONES_ETAPA0.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 }}>Estado</label>
              <select value={addForm.estado} onChange={e => setAddForm(f => ({...f, estado: e.target.value}))}
                style={{ width: '100%', padding: '6px 8px', borderRadius: 6, border: '1px solid #D1D5DB', fontSize: 12, outline: 'none' }}>
                {ESTADOS.map(e => <option key={e} value={e}>{e}</option>)}
              </select>
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 }}>Prioridad</label>
              <select value={addForm.prioridad} onChange={e => setAddForm(f => ({...f, prioridad: e.target.value}))}
                style={{ width: '100%', padding: '6px 8px', borderRadius: 6, border: '1px solid #D1D5DB', fontSize: 12, outline: 'none' }}>
                {PRIORIDADES.map(p => <option key={p} value={p}>{p.charAt(0).toUpperCase() + p.slice(1)}</option>)}
              </select>
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 }}>Fuente</label>
              <input value={addForm.fuente} onChange={e => setAddForm(f => ({...f, fuente: e.target.value}))} placeholder="Stakeholder o referencia"
                style={{ width: '100%', padding: '6px 8px', borderRadius: 6, border: '1px solid #D1D5DB', fontSize: 12, outline: 'none', boxSizing: 'border-box' }} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button onClick={() => setShowAdd(false)} style={{ padding: '7px 16px', borderRadius: 7, border: '1px solid #D1D5DB', background: '#fff', fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
            <button onClick={addAfirmacion} disabled={saving} style={{
              padding: '7px 16px', borderRadius: 7, border: 'none',
              background: saving ? '#A5B4FC' : '#6366F1', color: '#fff', fontSize: 13, fontWeight: 600, cursor: saving ? 'not-allowed' : 'pointer'
            }}>{saving ? 'Guardando…' : 'Agregar Afirmación'}</button>
          </div>
        </div>
      )}

      {view === 'lista' ? (
        <ListView
          filtered={filtered}
          filterSec={filterSec}
          setFilterSec={setFilterSec}
          filterEst={filterEst}
          setFilterEst={setFilterEst}
          expandedId={expandedId}
          setExpandedId={setExpandedId}
          updateEstado={updateEstado}
          deleteAfirmacion={deleteAfirmacion}
        />
      ) : (
        <DocumentoVivo afirmaciones={afirmaciones} />
      )}
    </div>
  )
}

function ListView({ filtered, filterSec, setFilterSec, filterEst, setFilterEst, expandedId, setExpandedId, updateEstado, deleteAfirmacion }) {
  return (
    <>
      {/* Filters */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
        <select value={filterSec} onChange={e => setFilterSec(e.target.value)}
          style={{ padding: '6px 10px', borderRadius: 7, border: '1px solid #D1D5DB', fontSize: 12, outline: 'none', background: '#fff' }}>
          <option value="Todas">Todas las secciones</option>
          {SECCIONES_ETAPA0.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <select value={filterEst} onChange={e => setFilterEst(e.target.value)}
          style={{ padding: '6px 10px', borderRadius: 7, border: '1px solid #D1D5DB', fontSize: 12, outline: 'none', background: '#fff' }}>
          <option value="Todos">Todos los estados</option>
          {ESTADOS.map(e => <option key={e} value={e}>{e}</option>)}
        </select>
        <span style={{ fontSize: 12, color: '#9CA3AF', alignSelf: 'center' }}>{filtered.length} afirmación{filtered.length !== 1 ? 'es' : ''}</span>
      </div>

      {filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 48, color: '#9CA3AF' }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>💬</div>
          <div>No hay afirmaciones que coincidan con los filtros</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {filtered.map(a => {
            const cfg = ESTADO_CONFIG[a.estado] || ESTADO_CONFIG['Sin validar']
            const isExpanded = expandedId === a.id
            return (
              <div key={a.id} style={{
                background: cfg.bg,
                border: `1px solid ${cfg.border}`,
                borderRadius: 10,
                overflow: 'hidden',
              }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '12px 14px', cursor: 'pointer' }}
                  onClick={() => setExpandedId(isExpanded ? null : a.id)}>
                  <span style={{ fontSize: 16, marginTop: 1 }}>{cfg.icon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, color: cfg.color, lineHeight: 1.5 }}>{a.texto}</div>
                    <div style={{ display: 'flex', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
                      <span style={{
                        fontSize: 10, fontWeight: 600, padding: '1px 7px', borderRadius: 99,
                        background: 'rgba(255,255,255,0.6)', color: cfg.color
                      }}>{a.seccion_nombre}</span>
                      {a.fuente && <span style={{ fontSize: 10, color: cfg.color, opacity: 0.7 }}>👤 {a.fuente}</span>}
                      {a.stakeholders?.nombre && <span style={{ fontSize: 10, color: cfg.color, opacity: 0.7 }}>🎤 {a.stakeholders.nombre}</span>}
                      <span style={{
                        fontSize: 10, fontWeight: 600, padding: '1px 7px', borderRadius: 99,
                        background: PRIO_COLORS[a.prioridad]?.bg, color: PRIO_COLORS[a.prioridad]?.color
                      }}>{a.prioridad}</span>
                    </div>
                  </div>
                  <span style={{ color: cfg.color, fontSize: 12, opacity: 0.6 }}>{isExpanded ? '▲' : '▼'}</span>
                </div>

                {isExpanded && (
                  <div style={{ padding: '0 14px 14px 14px', borderTop: `1px solid ${cfg.border}`, paddingTop: 12 }}>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 12, color: cfg.color, fontWeight: 600 }}>Cambiar estado:</span>
                      {ESTADOS.map(e => (
                        <button key={e} onClick={() => updateEstado(a.id, e)} style={{
                          padding: '4px 12px', borderRadius: 99, border: 'none', fontSize: 11,
                          fontWeight: 600, cursor: 'pointer',
                          background: a.estado === e ? ESTADO_CONFIG[e].border : 'rgba(255,255,255,0.5)',
                          color: ESTADO_CONFIG[e].color,
                        }}>{ESTADO_CONFIG[e].icon} {e}</button>
                      ))}
                      <div style={{ flex: 1 }} />
                      <button onClick={() => deleteAfirmacion(a.id)} style={{
                        padding: '4px 10px', borderRadius: 7, border: '1px solid #FCA5A5',
                        background: '#FEF2F2', color: '#EF4444', fontSize: 11, cursor: 'pointer'
                      }}>Eliminar</button>
                    </div>
                    <div style={{ marginTop: 8, fontSize: 11, color: cfg.color, opacity: 0.6 }}>
                      Creada: {new Date(a.created_at).toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                    </div>
                  </div>
                )}
              </div>
            )
          })}
        </div>
      )}
    </>
  )
}

// ─── Documento Vivo ──────────────────────────────────────────
function DocumentoVivo({ afirmaciones }) {
  return (
    <div style={{ background: '#FAFAFA', border: '1px solid #E5E7EB', borderRadius: 12, padding: 24 }}>
      <div style={{ fontSize: 16, fontWeight: 700, color: '#111827', marginBottom: 4 }}>Documento Vivo — Modelo de Negocio</div>
      <div style={{ fontSize: 12, color: '#9CA3AF', marginBottom: 24 }}>
        Vista de lectura. Muestra el estado actual de cada sección según las afirmaciones capturadas.
      </div>

      {SECCIONES_ETAPA0.map(seccion => {
        const secAfirm = afirmaciones.filter(a => a.seccion_nombre === seccion)
        const confirmadas  = secAfirm.filter(a => a.estado === 'Confirmada')
        const cuestionadas = secAfirm.filter(a => a.estado === 'Cuestionada')
        const sinValidar   = secAfirm.filter(a => a.estado === 'Sin validar')

        let semaforo = '⚪'
        if (secAfirm.length > 0) {
          if (cuestionadas.length > confirmadas.length) semaforo = '🔴'
          else if (confirmadas.length >= 2) semaforo = '🟢'
          else semaforo = '🟡'
        }

        return (
          <div key={seccion} style={{
            background: '#fff', border: '1px solid #E5E7EB', borderRadius: 10,
            marginBottom: 16, overflow: 'hidden'
          }}>
            <div style={{ padding: '12px 16px', borderBottom: '1px solid #F3F4F6', display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: 18 }}>{semaforo}</span>
              <span style={{ fontWeight: 700, fontSize: 14, color: '#111827', flex: 1 }}>{seccion}</span>
              <span style={{ fontSize: 11, color: '#9CA3AF' }}>{secAfirm.length} afirmación{secAfirm.length !== 1 ? 'es' : ''}</span>
            </div>

            {secAfirm.length === 0 ? (
              <div style={{ padding: '12px 16px', fontSize: 12, color: '#9CA3AF', fontStyle: 'italic' }}>
                Sin afirmaciones capturadas para esta sección.
              </div>
            ) : (
              <div style={{ padding: '12px 16px' }}>
                {[
                  { list: confirmadas, label: 'Confirmadas', cfg: ESTADO_CONFIG['Confirmada'] },
                  { list: cuestionadas, label: 'Cuestionadas', cfg: ESTADO_CONFIG['Cuestionada'] },
                  { list: sinValidar, label: 'Sin validar', cfg: ESTADO_CONFIG['Sin validar'] },
                ].map(({ list, label, cfg }) => list.length > 0 && (
                  <div key={label} style={{ marginBottom: 10 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: cfg.color, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6 }}>
                      {cfg.icon} {label}
                    </div>
                    {list.map(a => (
                      <div key={a.id} style={{
                        fontSize: 13, color: '#374151', lineHeight: 1.5,
                        paddingLeft: 12, borderLeft: `3px solid ${cfg.border}`,
                        marginBottom: 6, paddingTop: 2, paddingBottom: 2
                      }}>
                        {a.texto}
                        {(a.fuente || a.stakeholders?.nombre) && (
                          <span style={{ fontSize: 11, color: '#9CA3AF', marginLeft: 6 }}>
                            — {a.stakeholders?.nombre || a.fuente}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
